interface LoaderProps {
  icon?: React.ReactNode
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

export function Loader({ icon, className = '' }: LoaderProps) {
  /* HTML: <div class="loader"></div> */
  // .loader {
  //   width: 50px;
  //   padding: 8px;
  //   aspect-ratio: 1;
  //   border-radius: 50%;
  //   background: #25b09b;
  //   --_m:
  //     conic-gradient(#0000 10%,#000),
  //     linear-gradient(#000 0 0) content-box;
  //   -webkit-mask: var(--_m);
  //           mask: var(--_m);
  //   -webkit-mask-composite: source-out;
  //           mask-composite: subtract;
  //   animation: l3 1s infinite linear;
  // }
  // @keyframes l3 {to{transform: rotate(1turn)}}

  return (
    <div
      className={`w-60 h-60 relative flex items-center justify-center ${className}`}
    >
      {/* Custom CSS loader with rounded ends */}
      <div
        className='absolute inset-0 aspect-square rounded-full bg-blue-500 p-6'
        style={{
          mask: 'conic-gradient(from 0deg, transparent 10%, black), linear-gradient(black 0 0) content-box',
          WebkitMask:
            'conic-gradient(from 0deg, transparent 10%, black), linear-gradient(black 0 0) content-box',
          maskComposite: 'subtract',
          WebkitMaskComposite: 'source-out',
          animation: 'spin 1s linear infinite',
        }}
      />

      {icon && (
        <div className={`flex items-center justify-center relative z-10`}>
          {icon}
        </div>
      )}
    </div>
  )
}
